// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

export enum AttributeNames {
    SESSION_ID = 'session.id'
}
